var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('list',{attrs:{"label":_vm.$t('sessions'),"refresh":this.refresh,"table":"sessions","initialSortBy":"isactive","initialSortDesc":true,"hideNewAndEdit":true},on:{"childMessage":_vm.onMessageFromListReceived}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }